<template>

  <v-data-table
      :headers="headers"
      :items="achievementsKind"
      :single-expand="true"
      item-key="id"
      show-expand
      :items-per-page="itemsPerPage"
      hide-default-footer
      class="elevation-1"
  >
    <template #top>
      <v-toolbar
          flat
      >
        <v-toolbar-title>Виды достижений</v-toolbar-title>
        <v-divider
            class="mx-4"
            inset
            vertical
        ></v-divider>
        <v-spacer/>
        <v-btn
            @click="openDialog()"
            :color="$store.state.achievement.primary_color" class="white--text">
          Создать
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:expanded-item="{ headers, item}">
      <td :colspan="headers.length">
        <v-card elevation="0">
          <v-container>
            <v-row>
              <v-col cols="12" md="4">
                <p>Описание</p>
                <v-divider/>
                <div class="description">{{ item.description }}</div>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col cols="12" md="8">
                <p>Ед. измерения</p>
                <v-divider/>
                <units-table-card :units_achievement="item"/>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </td>
    </template>
    <template #no-data>
      <v-alert
          class="my-3"
          dense
          text
          type="warning"
      >
        Достижения отсутствуют
      </v-alert>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
          small
          class="mr-2"
          @click="editAchievementKind(idType,item.id, item)"
      >
        fa fa-edit
      </v-icon>
      <v-icon
          small
          class="mr-2"
          @click="deleteAchievementKind({idType: idType, idKind: item.id})"
      >
        fa fa-trash
      </v-icon>
      <v-icon
          @click="toggleHiddenAchievementKind({idType: idType, idKind: item.id})"
          small
          class="mr-2"
      >
        {{!item.is_hidden ? "fa fa-eye" : "fa fa-eye-slash"}}
      </v-icon>
    </template>
  </v-data-table>

</template>

<script>
import {mapActions, mapMutations} from "vuex";
const UnitsTableCard = () => import("../../Tabs/UnitsTableCard.vue")

export default {
  name: "AchievementKindCard",
  components: {UnitsTableCard},


  props: {
    achievementsKind: {
      Type: Array,
      required: true,
    },

    typeIndex: {
      Type: Number,
      require: true,
    },

    idType: {
      Type: Number,
      require: true,
    },
  },

  data() {
    return {
      itemsPerPage: 50,
      headers: [
        {
          text: 'Название',
          align: 'start',
          value: 'name',
          groupable: false,
          sortable: false,
        },
        { text: 'Действия', value: 'actions', sortable: false },
        { text: '', value: 'data-table-expand' },
      ],


    }
  },

   computed: {

   },

  methods: {
    ...mapMutations({
      setDialog: 'achievement_kind/setDialog',
      setAchievementEdit: 'achievement_kind/setAchievementEdit',
      setIdAchievementType: 'achievement_kind/setIdAchievementType',
      setIdAchievementKind: 'achievement_kind/setIdAchievementKind',
      setEditModeForm: 'achievement_kind/setEditModeForm',
    }),
    ...mapActions({
      deleteAchievementKind: 'achievement_kind/deleteAchievementKind',
      toggleHiddenAchievementKind: 'achievement_kind/toggleHiddenAchievementKind',
    }),

    editAchievementKind(id_type,id_kind, achievement) {
      this.setIdAchievementType(id_type);
      this.setIdAchievementKind(id_kind);
      this.setAchievementEdit(achievement);
      this.setEditModeForm(true);
      this.setDialog(true);
    },

    openDialog() {
      this.setIdAchievementType(this.idType);
      this.setDialog(true);
    },

  }

}
</script>

<style scoped>
.v-data-table >>> .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
  box-shadow: none;
}
</style>